"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Dom;
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var isServerSide = typeof window === 'undefined';
var measureDiv = null;
if (!isServerSide) {
    measureDiv = document.createElement('div');
    measureDiv.style.left = '0px';
    measureDiv.style.right = '0px';
    measureDiv.style.top = '0px';
    measureDiv.style.bottom = '0px';
    measureDiv.style.visibility = 'hidden';
    measureDiv.style.position = 'fixed';
    document.body.appendChild(measureDiv);
}
var DomClass = /*#__PURE__*/ function() {
    "use strict";
    function DomClass(node) {
        _classCallCheck(this, DomClass);
        this.node = node;
    }
    _createClass(DomClass, [
        {
            key: "getScrollNode",
            value: function getScrollNode() {
                // Fix for Edge; when the scroll element is the body, use the window,
                // because scroll events do not work properly on the body, also scrollTop is wrong
                // sowieso, als body of html scroller zijn gewoon window aanhouden
                if (this.node.tagName.toLowerCase() === 'html' || this.node.tagName.toLowerCase() === 'body') return window;
                if (this.node.scrollHeight > this.node.clientHeight || this.node.classList && this.node.classList.contains('overscroll-container')) {
                    return this.node;
                } else {
                    if (this.node.parentNode) return Dom(this.node.parentNode).getScrollNode();
                    else return window;
                }
            }
        },
        {
            key: "layout",
            value: function layout() {
                if (isServerSide) {
                    return {
                        width: 0,
                        height: 0,
                        top: 0,
                        left: 0
                    };
                }
                var width = this.node === window ? measureDiv.offsetWidth : this.node.offsetWidth;
                var height = this.node === window ? Math.min(document.documentElement.clientHeight, measureDiv.offsetHeight) : this.node.offsetHeight;
                var top = this.node === window ? 0 : this.node.offsetTop;
                var left = this.node === window ? 0 : this.node.offsetLeft;
                return {
                    width: width,
                    height: height,
                    top: top,
                    left: left
                };
            }
        },
        {
            key: "absoluteLayout",
            value: function absoluteLayout() {
                if (isServerSide) {
                    return {
                        width: 0,
                        height: 0,
                        top: 0,
                        left: 0
                    };
                }
                var width = this.node === window ? measureDiv.offsetWidth : this.node.offsetWidth;
                var height = this.node === window ? Math.min(window.innerHeight, measureDiv.offsetHeight) : this.node.offsetHeight;
                var left = 0;
                var top = 0;
                if (this.node !== window) {
                    top += this.node.offsetTop;
                    left += this.node.offsetLeft;
                    var parent = this.node.parentNode;
                    while(parent && parent !== window){
                        if (!isNaN(parent.offsetTop)) top += parent.offsetTop;
                        if (!isNaN(parent.offsetLeft)) left += parent.offsetLeft;
                        parent = parent.parentNode;
                    }
                }
                return {
                    width: width,
                    height: height,
                    top: top,
                    left: left
                };
            }
        },
        {
            key: "isFixed",
            value: function isFixed() {
                if (isServerSide) return false;
                if (this.node === window) return false;
                var style = getComputedStyle(this.node);
                if (style.position === "fixed") return true;
                if (this.node.parentNode) return Dom(this.node.parentNode).isFixed();
                return false;
            }
        },
        {
            key: "scrollTop",
            value: function scrollTop() {
                if (isServerSide) return 0;
                var supportPageOffset = window.pageXOffset !== undefined;
                var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
                var scrollTop1 = this.node === window ? supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop : this.node.scrollTop;
                return scrollTop1;
            }
        },
        {
            key: "scrollLeft",
            value: function scrollLeft() {
                if (isServerSide) return 0;
                var supportPageOffset = window.pageXOffset !== undefined;
                var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
                var scrollLeft1 = this.node === window ? supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft : this.node.scrollLeft;
                return scrollLeft1;
            }
        },
        {
            key: "scrollWidth",
            value: function scrollWidth() {
                if (isServerSide) return 0;
                var supportPageOffset = window.pageXOffset !== undefined;
                var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
                var scrollWidth1 = this.node === window ? supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollWidth : document.body.scrollWidth : this.node.scrollWidth;
                return scrollWidth1;
            }
        },
        {
            key: "scrollHeight",
            value: function scrollHeight() {
                if (isServerSide) return 0;
                var supportPageOffset = window.pageXOffset !== undefined;
                var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
                var scrollHeight1 = this.node === window ? supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollHeight : document.body.scrollHeight : this.node.scrollHeight;
                return scrollHeight1;
            }
        },
        {
            key: "scrollTo",
            value: function scrollTo(position, animate) {
                var direction = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'vertical';
                if (isServerSide) return Promise.resolve();
                var node = this.node;
                return new Promise(function(resolve) {
                    if (!animate) {
                        if (direction === 'horizontal') {
                            if (node === window) node.scrollTo(position, 0);
                            else node.scrollLeft = position;
                        } else {
                            if (node === window) node.scrollTo(0, position);
                            else node.scrollTop = position;
                        }
                        resolve();
                    } else {
                        smoothScroll(node, position, direction).then(function() {
                            resolve();
                        });
                    }
                });
            }
        }
    ]);
    return DomClass;
}();
function smoothScroll(node, target, direction) {
    return new Promise(function(resolve) {
        var smoothScrollNativeSupport = 'scroll-behavior' in document.documentElement.style;
        if (smoothScrollNativeSupport) {
            var options = {};
            if (direction === 'horizontal') {
                options = {
                    "behavior": "smooth",
                    "left": target
                };
            } else {
                options = {
                    "behavior": "smooth",
                    "top": target
                };
            }
            node.scrollTo(options);
            onScrollFinished(node).then(function() {
                resolve();
            });
        } else {
            smoothScrollFallback(node, target, direction).always(function() {
                resolve();
            });
        }
    });
}
// Watch node for scrollEvents if no scroll events happened for 25ms then resolve
function onScrollFinished(node) {
    return new Promise(function(resolve) {
        var scrollDoneTimer = setTimeout(function() {
            resolve();
        }, 25);
        var hasScrolled = function() {
            clearTimeout(scrollDoneTimer);
            scrollDoneTimer = setTimeout(function() {
                node.removeEventListener('scroll', hasScrolled, {
                    passive: true
                });
                resolve();
            }, 25);
        };
        node.addEventListener('scroll', hasScrolled, {
            passive: true
        });
    });
}
function smoothScrollFallback(element, target, direction) {
    var currentPosition = direction === 'horizontal' ? Dom(element).scrollLeft() : Dom(element).scrollTop();
    var diff = Math.abs(currentPosition - target);
    var duration = diff * 0.75;
    duration = Math.min(400, duration);
    target = Math.round(target);
    duration = Math.round(duration);
    var start_time = Date.now();
    var end_time = start_time + duration;
    var start_position = direction === 'horizontal' ? Dom(element).scrollLeft() : Dom(element).scrollTop();
    var distance = target - start_position;
    var smooth_step = function smooth_step(start, end, point) {
        if (point <= start) {
            return 0;
        }
        if (point >= end) {
            return 1;
        }
        var x = (point - start) / (end - start); // interpolation
        return x * x * (3 - 2 * x);
    };
    return (function() {
        // This is to keep track of where the element's scrollTop is
        // supposed to be, based on what we're doing
        var previous_position = direction === 'horizontal' ? Dom(element).scrollLeft() : Dom(element).scrollTop();
        var doneCallback = null;
        var alwaysCallback = null;
        // This is like a think function from a game loop
        var scroll_frame = function() {
            // set the scrollTop for this frame
            var now = Date.now();
            var point = smooth_step(start_time, end_time, now);
            var framePos = Math.round(start_position + distance * point);
            Dom(element).scrollTo(framePos, false, direction);
            // check if we're done!
            if (now >= end_time) {
                requestAnimationFrame(function() {
                    if (doneCallback) doneCallback();
                    if (alwaysCallback) alwaysCallback();
                });
                return;
            }
            // If we were supposed to scroll but didn't, then we
            // probably hit the limit, so consider it done; not
            // interrupted.
            var curScrollPos = direction === 'horizontal' ? Dom(element).scrollLeft() : Dom(element).scrollTop();
            if (curScrollPos === previous_position && curScrollPos !== framePos) {
                requestAnimationFrame(function() {
                    if (doneCallback) doneCallback();
                    if (alwaysCallback) alwaysCallback();
                });
                return;
            }
            previous_position = direction === 'horizontal' ? Dom(element).scrollLeft() : Dom(element).scrollTop();
            // schedule next frame for execution
            requestAnimationFrame(scroll_frame);
        };
        // boostrap the animation process
        setTimeout(function() {
            requestAnimationFrame(scroll_frame);
        }, 1);
        var returnValue = {
            done: function done(callback) {
                doneCallback = callback;
                return returnValue;
            },
            always: function always(callback) {
                alwaysCallback = callback;
                return returnValue;
            }
        };
        return returnValue;
    })();
}
function Dom(node) {
    return new DomClass(node);
}


//# sourceMappingURL=index.js.map